export const minLengthMessage = (field: string, quantity: number) =>
  `${field} must be at least ${quantity} characters.`;

export const maxLengthMessage = (field: string, quantity: number) =>
  `${field} must have ${quantity} characters max.`;
